enum RouteSubPath {
  CREATE = "create",
  EDIT = "edit",
  LIST = "list",
  UPCOMING = "upcoming",
  VIEW = "view",
}

export default RouteSubPath;
